var styles = {"imagePreview":"styles_image-preview__icqNW","tools":"styles_tools__-o7Hv","toolButton":"styles_tool-button__AL-9Q","wrapper":"styles_wrapper__a8Joj","image":"styles_image__6tHj0"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
